import { BriefcaseIcon as PhosphorBriefcaseIcon } from "@phosphor-icons/react/dist/ssr/Briefcase";

import { createAppIcon } from "@/components/createAppIcon";

export const WorkHistoryIcon = /* @__PURE__ */ createAppIcon(PhosphorBriefcaseIcon);
